import React from 'react';
export function SecretsSection() {
  const secrets = [{
    icon: '🧄',
    title: 'La Regla de los 15 Minutos del Ajo',
    text: 'El paso de preparación que activa la alicina y potencia su efecto sobre la presión arterial, la inflamación y la salud cardiovascular. El 99% lo omite.'
  }, {
    icon: '🌿',
    title: 'La Trampa de la Cúrcuma',
    text: 'Por qué tomar cúrcuma sola es casi inútil — y el ingrediente de cocina que multiplica su poder por 2.000%. Ya lo tenés en tu especiero.'
  }, {
    icon: '🌱',
    title: 'El Analgésico del Patio',
    text: 'Ignorada por la mayoría, esta planta común puede calmar el dolor articular más rápido que tus analgésicos habituales de venta libre.'
  }, {
    icon: '😴',
    title: 'El Interruptor del Sueño Herbal',
    text: "La combinación de 2 hierbas que cambia tu sistema nervioso de 'alerta' a 'descanso' de forma natural y confiable — sin pastillas."
  }, {
    icon: '💪',
    title: 'El Secreto de Sinergia para el Dolor',
    text: 'Cómo combinar dos hierbas familiares para crear un alivio que rivaliza con los antiinflamatorios de venta libre — sin efectos secundarios.'
  }, {
    icon: '🫚',
    title: 'Los Elíxires de Especias que Sanan',
    text: '¿Qué pasa cuando combinás canela, limón y aceite? Un tónico que potencia la inmunidad, la energía y la digestión al mismo tiempo.'
  }];
  return <section className="py-20 bg-crema paper-texture" data-id="element-262">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
        <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-264">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-marron mb-6" data-id="element-265">
            Estás Usando Estos Ingredientes de Forma Incorrecta…
          </h2>
          <p className="text-lg text-marron-light" data-id="element-266">
            Pequeños cambios. Grandes resultados. Estos ingredientes de tu
            cocina tienen poderes que solo se activan si sabés cómo
            desbloquearlos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-267">
          {secrets.map((secret, i) => <div key={i} className="bg-white p-6 sm:p-8 rounded-xl shadow-sm border border-oliva/20 hover:shadow-md hover:-translate-y-1 transition-all duration-300" data-id="element-268">
              <div className="text-4xl mb-4" data-id="element-269">{secret.icon}</div>
              <h4 className="text-xl font-heading font-bold text-marron mb-3" data-id="element-270">
                {secret.title}
              </h4>
              <p className="text-marron-light leading-relaxed" data-id="element-271">{secret.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}